import { array, object } from 'common/helpers'


const initialActiveFilters = {
  gender: 'female',
  category: 'all', // all | bestsellers | newarrivals | featured
  tags: [],
  brands: [],
  notes: [],
  types: [],
  rating: 0,
}

export const initialState = {
  isFetching: false,
  isFetched: false,
  isTagsOverlayVisible: false,
  isFiltersOverlayVisible: false,
  filtersOverlayInitialFilter: null,
  fragrances: [],
  filters: {
    tags: {
      male: [],
      female: [],
    },
    brands: [],
    notes: [],
    types: [],
    rating: 0,
  },
  activeFilters: initialActiveFilters,
}

export const setFetching = (state, payload) =>
  ({ ...state, isFetching: payload })

export const setFetched = (state, payload) =>
  ({ ...state, isFetched: payload })

export const setFragrances = (state, payload) =>
  ({ ...state, isFetching: false, isFetched: true, fragrances: payload })

export const setBrands = (state, payload) =>
  object.setIn(state, [ 'filters', 'brands' ], payload)

export const setNotes = (state, payload) =>
  object.setIn(state, [ 'filters', 'notes' ], payload)

export const setTypes = (state, payload) =>
  object.setIn(state, [ 'filters', 'types' ], payload)

export const setTagsMale = (state, payload) =>
  object.setIn(state, [ 'filters', 'tags', 'male' ], payload)

export const setTagsFemale = (state, payload) =>
  object.setIn(state, [ 'filters', 'tags', 'female' ], payload)

export const setTagsOverlayVisibility = (state, payload) =>
  ({ ...state, isTagsOverlayVisible: payload })

export const setFiltersOverlayVisibility = (state, payload) =>
  ({ ...state, isFiltersOverlayVisible: payload })

export const setFiltersOverlayInitialFilter = (state, payload) =>
  ({ ...state, filtersOverlayInitialFilter: payload })

export const setActiveCategory = (state, payload /* category */) =>
  ({
    ...state,
    activeFilters: {
      gender: state.activeFilters.gender || 'female',
      rating: 0,
      category: payload,
      tags: [],
      brands: [],
      notes: [],
      types: [],
    },
  })

export const setActiveRating = (state, payload /* rating */) =>
  object.setIn(state, [ 'activeFilters', 'rating' ], payload)

export const setActiveGender = (state, payload /* gender */) =>
  object.setIn(state, [ 'activeFilters', 'gender' ], payload)

export const toggleActiveTag = (state, payload /* tagId */) =>
  object.update(state, 'activeFilters', (activeFilters) => ({
    ...activeFilters,
    category: 'all',
    tags: array.toggle(activeFilters.tags, payload),
  }))

export const toggleActiveBrand = (state, payload /* brandName */) =>
  object.update(state, 'activeFilters', (activeFilters) => ({
    ...activeFilters,
    category: 'all',
    brands: array.toggle(activeFilters.brands, payload),
  }))

export const toggleActiveNote = (state, payload /* noteName */) =>
  object.update(state, 'activeFilters', (activeFilters) => ({
    ...activeFilters,
    category: 'all',
    notes: array.toggle(activeFilters.notes, payload),
  }))

export const toggleActiveType = (state, payload /* typeName */) =>
  object.update(state, 'activeFilters', (activeFilters) => ({
    ...activeFilters,
    category: 'all',
    types: array.toggle(activeFilters.types, payload),
  }))

export const toggleActiveFilter = (state, { activeFilter, value }) =>
  object.updateIn(state, [ 'activeFilters', activeFilter ], (activeFilter) => array.toggle(activeFilter, value))

export const clearTagFilters = (state) =>
  object.setIn(state, [ 'activeFilters', 'tags' ], [])

export const clearBrandFilters = (state) =>
  object.setIn(state, [ 'activeFilters', 'brands' ], [])

export const clearFilters = (state) =>
  ({
    ...state,
    activeFilters: initialActiveFilters,
  })
